import React, { useEffect, useState } from "react";
import {
    Grid,
    TextField,
    FormControl,
    Autocomplete,
    Box,
    TableContainer,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    IconButton,
    InputAdornment } from "../ui";
import SearchIcon from "../ui/icons/Search";
import ClearIcon from "../ui/icons/Clear";
import {
  SUCCESS,
  getAuthSession,
  updateSessionState,
  getPreUrlAccordingToCart,
  SHOWCONFIGS,
  ConfigInputType,
  isEmpty,
  PERSISTCONFIGS,
  CartDets,
  OFFLINEIP,
  DEFDASHBOARDSCREEN,
  DashboardComponent,
  printDebugLog,
  DEFBALANCETYPE,
  printInfoLog,
  MAINACCOUNTING,
  GETVIDEOPATH,
  GETSINGLECONFIGS,
  TABLESYSTEMBILL,
  DEF_BILL_PRICES,
  DEF_SELECT_SEARCH,
  SearchOption,
  isFeatureAllowed,
  COMBOMGMT,
  ChooseItemPrices,
  DEF_RESTO_BILLING_UI,
  RANGE_DELIVERYCHARGE,
  ONLINEBILLMGMT,
  BILLMGMT,
  isOtherRoleAllowed,
  OTHER_ADMIN_RIGHTS
  ,SEARCH_CONFIGURATION_FEATURES
  ,ADD_CONFIGURATION_FROM_FEATURE
} from "../../constants/constant";
import DialogBox from "../global/DialogBox";
import CustomDataGrid from "../global/CustomDataGrid";
import {
    Button, RadioGroup, FormControlLabel,
    FormLabel, Radio
} from "../ui";
import { useSelector } from "react-redux";
import SnpComponent from "../global/SnpComponent";
import imageUploadService from "../../service/imageUploadService";
import { snpAxios } from "../global/api";
import { SCREEN_CONFIG } from "../../constants/VideoConstant";
import axios from "axios";
import YouTubeVideo from "../global/YouTubeVideo";
import SingleFab from "../global/fab/SingleFab";
import EnterButton from "../global/EnterButton";
import SnpButton from "../global/SnpButton";
import DismissButton from "../global/DismissButton";
import { useNavigate } from "react-router-dom";

import SnpDateTimePicker from "../global/SnpDateTimePicker";
import PasswordDialog from "../global/Alert/PasswordDialog";
import AboutItemEditor from "../product/mart/AboutItemEditor";

export default function Configuration() {
    const storeActiveShopHash = useSelector(state => state.setActiveShopHashReducer.activeShopHash);
    const storeApiUrl = useSelector(state => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL);

    const navigate = useNavigate();


    const [showPassword, setShowPassword] = useState(false);
    const [adminCode, setAdminCode] = useState("");
    const [adminMode, setAdminMode] = useState(false);
    const [availableFeatures, setAvailableFeatures] = useState([]);
    const [configurationUsers, setConfigurationUsers] = useState([]);
    const [selectedFeature, setSelectedFeature] = useState(null);
    const [selectedConfigUser, setSelectedConfigUser] = useState(null);

    const [showDialog, setShowDialog] = useState(false);
    const [isEditProduct, setEditProduct] = useState(false);
    const [selectedImage, setSelectedImage] = useState('');
    const [imageSelectedError, setImageSelectedError] = useState(false);
    const [uploadedDocument, setUploadedDocument] = useState("");
    const [tableSystemAllowed, setTableSystemAllowed] = useState(false);
    const [rangeDelvChangeAllowed, setRangeDelvChangeAllowed] = useState(false);
    const INITIAL_SNP_COMPONENT = {
        showDialog: false,
        outSideClickDismiss: false,
        title: "",
        subTitle: "",
        negativeAction: "",
        positiveAction: "",
        positiveReq: false,
        isLoader: false,
        iconReq: "",
        snackBarOpen: false,
        snackBarMsg: "",
        cancelExtra: false,
        negativeReq: false,
        requestType: 0,
    };
    const [videoModel, setVideoModel] = useState({ show: false, path: "" });
    const [snpComponent, setSnpComponent] = useState(INITIAL_SNP_COMPONENT);
    const INITIAL_CONFIGS = {
        id: "",
        configName: "",
        configNameStr: "",
        prefix: "",
        val: "",
        valNum: 0,
        valDate: "",
        valBool: false,
        list: [],
        map: {},
        comments: "",
		multiple: false,
        valType: 0,
        allowed: true,
        optionsList: [],
        optionsMap: {},
        type: -1,
        visible: false,
        defaultVal: "",
        groups: [],
        featureId: "",
        shopperId: "",
    };
    const [configs, setConfigs] = useState(INITIAL_CONFIGS);
    const [listConfigs, setListConfigs] = useState([]);
    const [configSearchInput, setConfigSearchInput] = useState("");
    const [configSearch, setConfigSearch] = useState("");
    const [listAcc, setListAcc] = useState([]);

    const filteredConfigs = listConfigs.filter((config) => {
        const searchValue = configSearch.trim().toLocaleLowerCase();
        if (!searchValue) return true;
        return (config.configNameStr || config.configName || "")
            .toLocaleLowerCase()
            .includes(searchValue);
    });

    const handleConfigSearchInput = (value) => {
        setConfigSearchInput(value);
        const normalizedValue = value.trim();
        setConfigSearch(normalizedValue.length >= 2 ? normalizedValue : "");
    };

    const [listInput, setListInput] = useState("");
    const [pInput, setPInput] = useState("");
    const [listItems, setListItems] = useState([]);
    const [mapItems, setMapItems] = useState({});
    const [mapKey, setMapKey] = useState("");
    const [mapValue, setMapValue] = useState("");
    const [richEditorOpen, setRichEditorOpen] = useState(false);

    const columns = [
        { field: 'configNameStr', headerName: 'Config Name', width: 280 },
        { field: 'prefix', headerName: 'Config Type', width: 180 },
        { field: 'visible', headerName: 'Visible', width: 90, valueFormatter: ({ value }) => value ? 'Yes' : 'No' },
        {
            field: "edit",
            headerName: "Edit",
            width: 80,
            renderCell: (cellValues) => {
                return (
                    <SnpButton variant="contained"
                        mbgcolor="#538796"
                        mpadding="1px"
                        onClick={(event) => handleCellClick(event, cellValues)}
                    >Edit</SnpButton>
                );
            }
        }
    ];


    const columnsAdmin = [
        { field: 'employeeName', headerName: 'Emp. Name', width: 180 },
        { field: 'configNameStr', headerName: 'Config Name', width: 280 },
        { field: 'prefix', headerName: 'Config Type', width: 120 },
        { field: 'visible', headerName: 'Visible', width: 90, valueFormatter: ({ value }) => value ? 'Yes' : 'No' },
        {
            field: 'displayVal',
            headerName: 'Value',
            width: 250,
            renderCell: (cellValues) => {
                return (
                    cellValues.row.valType === ConfigInputType.ATTACHMENT ? (
                        !isEmpty(cellValues.row.displayVal) &&
                        <div>
                            <img
                                alt=""
                                style={{ height: "80px", width: "80px", borderRadius: "40%" }}
                                src={`${storeApiUrl.BACKEND_BASE_URL}files/${cellValues.row.displayVal}`}
                            />
                        </div>
                    ) : (
                        <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{cellValues.row.displayVal}</p>
                    )
                );
            }
        },
        { field: 'allowedStr', headerName: 'Allowed', width: 150 },
        {
            field: "edit",
            headerName: "Edit",
            width: 90,
            renderCell: (cellValues) => {
                return (
                    <SnpButton variant="contained"
                        mbgcolor="#538796"
                        mpadding="1px"
                        onClick={(event) => handleCellClick(event, cellValues)}
                    >Edit</SnpButton>
                );
            }
        }
    ];


    const optionList = [
        { id: SearchOption.SEARCHBYBARC, optName: "Bar Code" },
        { id: SearchOption.SEARCHBYCUSTOMBARCODE, optName: "Custom Bar Code" },
        { id: SearchOption.SEARCHBYBATCHN, optName: "Batch Number" },
        { id: SearchOption.SEARCHBYPRODN, optName: "Product Details" }
    ];
    const optionComboList = [
        { id: SearchOption.SEARCHBYBARC, optName: "Bar Code" },
        { id: SearchOption.SEARCHBYCUSTOMBARCODE, optName: "Custom Bar Code" },
        { id: SearchOption.SEARCHBYCOMBO, optName: "Combo Search" },
        { id: SearchOption.SEARCHBYBATCHN, optName: "Batch Number" },
        { id: SearchOption.SEARCHBYPRODN, optName: "Product Details" }
    ];


    const updateListItem = () => {
        if (!listInput.trim()) return;
        if (isEmpty(pInput)) {
            setListItems([...listItems, listInput]);
        } else {
            const index = listItems.findIndex(
                (item) => item.toLowerCase() === pInput.toLowerCase()
            );

            if (index !== -1) {
                const updated = [...listItems];
                updated[index] = listInput;
                setListItems(updated);
            } else {
                setListItems([...listItems, listInput]);
            }
        }
        setPInput('')
        setListInput("");
    };

    const deleteItem = (index, type, key) => {
        if (type === "list") {
            setListItems(listItems.filter((_, i) => i !== index));
        }
    };


    const handleDeleteImage = () => {
        setSelectedImage("");
    }

    const handleCellClick = (param, event) => {
        setEditProduct(true);
        if (adminMode && event.row.shopperId) {
            setSelectedConfigUser(configurationUsers.find(user => user.id === event.row.shopperId) || null);
        }
        //console.log("handleCellClick=>", event.row)
        if (event.row.valType === ConfigInputType.ATTACHMENT && !isEmpty(event.row.val)) {
            setSelectedImage(storeApiUrl.BACKEND_BASE_URL + "files/" + event.row.val)
        }
        setShowDialog(true);
        setConfigs({
            id: event.row.id,
            configName: event.row.configName,
            configNameStr: event.row.configNameStr,
            prefix: event.row.prefix,
            val: event.row.val ?? "",
            valNum: event.row.valNum ?? 0,
            valDate: event.row.valDate ?? "",
            valBool: event.row.valBool ?? false,
            list: event.row.list || (event.row.valType === ConfigInputType.LIST ? event.row.val || [] : []),
            map: event.row.map || {},
            comments: event.row.comments,
			multiple: event.row.multiple,
            valType: event.row.valType,
            allowed: event.row.allowed,
            optionsList: event.row.optionsList || [],
            optionsMap: event.row.optionsMap || {},
            type: event.row.type,
            visible: event.row.visible,
            defaultVal: event.row.defaultVal ?? "",
            groups: event.row.groups || [],
            featureId: event.row.featureId,
            shopperId: event.row.shopperId,
        });

        setListItems(event.row.list || (event.row.valType === ConfigInputType.LIST ? event.row.val || [] : []));
        setMapItems(event.row.map || (event.row.valType === ConfigInputType.MAP ? event.row.val || {} : {}));
    };

    const getSingleConfigs = async (mConfigName) => {
        try {
            const cUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}${GETSINGLECONFIGS}?adminId=${getAuthSession().apiToken}&configName=${mConfigName}&shopHash=${storeActiveShopHash.id}`;
            const response = await axios.get(cUrl);
            printDebugLog(`getSingleConfigs:${mConfigName}`, response);
            if (response.data !== '') {
                if (mConfigName === TABLESYSTEMBILL) {
                    setTableSystemAllowed(response.data === 'Yes');
                } else if (mConfigName === RANGE_DELIVERYCHARGE) {
                    setRangeDelvChangeAllowed(response.data === 'Yes');
                }
            }
        } catch (e) {
            console.error("getSingleConfigs:error", e);
        }
    };

    const getConfigs = async (pApiAllow = false, code = adminCode) => {
        try {
            const cUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}${SHOWCONFIGS}`;
            setSnpComponent({
                ...snpComponent,
                isLoader: true,
            });
            const data = {
                jcJson: {
                    apiToken: getAuthSession().apiToken,
                    shopHash: storeActiveShopHash.id,
                    hiddenApiFetch: pApiAllow,
                    ...(pApiAllow ? { adminCode: code } : {}),
                }
            };
            const response = await snpAxios.post(cUrl, data);
            printDebugLog("getConfigs", response.data);
            if (response.data.status === SUCCESS) {
                setListAcc(response.data.jcJson.delvList);
                setListConfigs(response.data.jcJson.value_2);
            }
            setSnpComponent({
                ...snpComponent,
                isLoader: false,
            });
        } catch (error) {
            setSnpComponent({
                ...snpComponent,
                isLoader: false,
            });
            console.log("getConfigs ", error);
        }
    };

    const searchConfigurationFeatures = async (query = "", code = adminCode) => {
        const cUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}${SEARCH_CONFIGURATION_FEATURES}`;
        const response = await snpAxios.post(cUrl, { jcJson: {
            apiToken: getAuthSession().apiToken, shopHash: storeActiveShopHash.id,
            adminCode: code, query
        }});
        if (response.data.status === SUCCESS) {
            setAvailableFeatures(response.data.jcJson.features || []);
            setConfigurationUsers(response.data.jcJson.users || []);
            if (!selectedConfigUser && response.data.jcJson.users?.length) {
                setSelectedConfigUser(response.data.jcJson.users[0]);
            }
        }
    };

    const addConfigurationFromFeature = async () => {
        if (!selectedFeature || !selectedConfigUser) return;
        const cUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}${ADD_CONFIGURATION_FROM_FEATURE}`;
        const response = await snpAxios.post(cUrl, { jcJson: {
            apiToken: getAuthSession().apiToken, shopHash: storeActiveShopHash.id,
            adminCode, featureId: selectedFeature.id, userId: selectedConfigUser.id
        }});
        if (response.data.status === SUCCESS) {
            setSelectedFeature(null);
            await getConfigs(true, adminCode);
        }
    };
    const handleDialogClose = () => {
        // console.log("handleDialogClose");
        setConfigs(INITIAL_CONFIGS);
        setShowDialog(false);
        setEditProduct(false);
        setSelectedImage('');
        setImageSelectedError(false);
        setUploadedDocument('');
        setMapItems({});
    };
    useEffect(() => {
        //console.log("useEffect",getAuthSession)
        getSingleConfigs(TABLESYSTEMBILL);
        getSingleConfigs(RANGE_DELIVERYCHARGE);
        getYoutubeVideo(SCREEN_CONFIG, 'hi');
        getConfigs();
    }, [storeActiveShopHash, storeApiUrl]);

    useEffect(() => {
        const handleKeyDown = (e) => {
            // Check if Ctrl + Shift + Alt + P are pressed together
            printDebugLog(" config keyDown ", e.ctrlKey, e.altKey, e.key);
            if (e.ctrlKey && e.shiftKey && e.altKey && e.key === '(') {
                e.preventDefault();
                setShowPassword(true);
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [])

    const getYoutubeVideo = async (videoName, lang) => {
        try {
            const cUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}${GETVIDEOPATH}?adminId=${getAuthSession().apiToken}&name=${videoName}&lang=${lang}`;
            const response = await axios.get(cUrl);
            printDebugLog(`getYoutubeVideo`, response);
            if (response.data !== '') {
                setVideoModel({ ...videoModel, path: response.data });
            } else {
                setVideoModel({ ...videoModel, path: '' });
            }
        } catch (e) {
            console.error("getYoutubeVideo:error", e);
            setVideoModel({ ...videoModel, path: '' });
        }
    };



    const handleFileUpload = async () => {
        if (configs.valType === ConfigInputType.ATTACHMENT) {
            if (uploadedDocument) {
                setSnpComponent({
                    ...snpComponent,
                    isLoader: true,
                });
                const formData = new FormData();
                formData.append('fnm', getAuthSession().apiToken);
                formData.append("file", uploadedDocument);
                await imageUploadService.upload(storeApiUrl.BACKEND_BASE_URL, getPreUrlAccordingToCart(storeActiveShopHash.cartType), formData).then(response => {
                    console.log("folderName", response.data);
                    if (response.data.folderName) {
                        configs.val = response.data.folderName;
                        handleConfigSubmit();
                    }
                }
                ).catch(error => {
                    console.log("handleFileUpload = > ", error);
                    // window.location.href = "#/error";
                });
            } else {
                setSnpComponent({
                    ...snpComponent,
                    isLoader: true,
                });
                handleConfigSubmit();
            }
        } else {
            setSnpComponent({
                ...snpComponent,
                isLoader: true,
            });
            handleConfigSubmit();
        }
    };

    const getUpdatedVal = (valType, defVal) => {
        if (valType === ConfigInputType.LIST) {
            return listItems;
        }
        if (valType === ConfigInputType.MAP) return mapItems;
        return defVal;
    }

    const typedValuePayload = (valType, value) => {
        if (valType === ConfigInputType.NUMBER) return { valNum: value === "" ? 0 : Number(value) };
        if (valType === ConfigInputType.DATE || valType === ConfigInputType.DATETIME) return { valDate: value };
        if (valType === ConfigInputType.BOOL) return { valBool: value === true || value === "true" };
        if (valType === ConfigInputType.LIST) return { list: value };
        if (valType === ConfigInputType.MAP) return { map: value };
        return { val: value };
    };

    const typedFeatureDefault = (valType, value) => {
        if (valType === ConfigInputType.NUMBER) return value === "" ? 0 : Number(value);
        if (valType === ConfigInputType.BOOL) return value === true || value === "true" || value === "Yes";
        if (valType === ConfigInputType.LIST && !Array.isArray(value))
            return String(value || "").split(",").map(item => item.trim()).filter(Boolean);
        if (valType === ConfigInputType.MAP && typeof value === "string") {
            try { return JSON.parse(value || "{}"); } catch (_) { return {}; }
        }
        return value;
    };

    const handleConfigSubmit = () => {
        const cUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}${PERSISTCONFIGS}`;
        const mVal = getUpdatedVal(configs.valType, configs.val);
        const data = {
            jcJson: {
                apiToken: getAuthSession().apiToken,
                shopHash: storeActiveShopHash.id,
                id: configs.id,
                configName: configs.configName,
                prefix: configs.prefix,
                comments: configs.comments,
                ...typedValuePayload(configs.valType, mVal),
                allowed: configs.allowed,
                ...(adminMode ? {
                    adminCode,
                    hiddenApiFetch: true,
                    updateFeatureMetadata: true,
                    val: configs.val ?? "",
                    valNum: configs.valNum === "" ? 0 : Number(configs.valNum),
                    valDate: configs.valDate || null,
                    valBool: configs.valBool === true || configs.valBool === "true",
                    list: listItems,
                    map: mapItems,
                    type: Number(configs.type),
                    valType: Number(configs.valType),
                    visible: configs.visible === true || configs.visible === "true",
                    defaultVal: typedFeatureDefault(configs.valType, configs.defaultVal),
                    groups: configs.groups || [],
                    optionsList: configs.optionsList || [],
                    optionsMap: configs.optionsMap || {},
                } : {}),
            }
        };
        setShowDialog(false);
        //console.log("handleConfigSubmit=>",data);
        snpAxios.post(cUrl, data)
            .then((response) => {
                //console.log("handleConfigSubmit<=", response.data);
                if (response.data.status === SUCCESS) {
                    if (configs.configName === OFFLINEIP) {
                        setSnpComponent({
                            ...snpComponent,
                            isLoader: false,
                            negativeReq: true,
                            negativeAction: "Ok",
                            showDialog: true,
                            outSideClickDismiss: true,
                            cancelExtra: true,
                            requestType: 1,
                            subTitle: "Your IP is changed, Please Logout and again login for changes to take effect"
                        });
                    } else if (configs.configName === DEFDASHBOARDSCREEN) {
                        updateSessionState({ defScreen: Number(configs.val) });
                        getConfigs(adminMode);
                    } else if (configs.configName === DEFBALANCETYPE) {
                        updateSessionState({ defBalanceType: configs.val });
                        getConfigs(adminMode);
                    } else if (configs.configName === DEF_RESTO_BILLING_UI) {
                        updateSessionState({ defBillUi: Number(configs.val) });
                        getConfigs(adminMode);
                    } else {
                        getConfigs(adminMode);
                    }
                    setListItems([]);
                } else {
                    setSnpComponent({
                        ...snpComponent,
                        isLoader: false,
                    });
                }
            }).catch((error) => {
                setSnpComponent({
                    ...snpComponent,
                    isLoader: false,
                });
                console.log("handleConfigSubmit ", error);
            });
    };
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        printDebugLog("handleInputChange", name, value);
        if (name === 'imgPath') {
            let file = event.target.files[0];
            setUploadedDocument(file);
            if (file) {
                setImageSelectedError(false);
                const reader = new FileReader();
                //const url = reader.readAsDataURL(file);

                reader.onloadend = function (e) {
                    console.log('onloadend', reader.result);
                    setSelectedImage(reader.result)
                }

            } else {
                setImageSelectedError(true);
            }
        } else {
            setConfigs({
                ...configs,
                [name]: (name === "type" || name === "valType") ? Number(value) : value,
            });

        }
    };
    const handleBalanceTypeChanged = (e, balanceType) => {
        printInfoLog("handleBalanceTypeChanged", balanceType);
        if (!isEmpty(balanceType)) {
            setConfigs({
                ...configs,
                val: balanceType,
            });
        } else {
            setConfigs({
                ...configs,
                val: MAINACCOUNTING,
            });
        }
    };

    const renderListView = () => {
        return (
            <Grid container spacing={1}>
                <Grid item xs={12} md={8} sm={6}>
                    <TextField
                        label="Enter Item"
                        value={listInput}
                        onChange={(e) => setListInput(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} md={4} sm={6}>
                    <SnpButton variant="contained" color="primary" mbgcolor="#538796" onPointerDown={() => updateListItem()}>
                        {isEmpty(pInput) ? "Add" : "Update"}
                    </SnpButton>
                </Grid>
                <Grid item xs={12}>
                    <TableContainer component={Paper} elevation={3} sx={{
                        maxHeight: 300,
                        overflowY: "auto",
                        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
                        border: "none",
                        borderRadius: 2,
                    }}
                    >
                        <Table>
                            <TableHead>
                                <TableRow sx={{
                                    backgroundColor: "#01333e",
                                    "& .UiTableCell-root": {
                                        color: "#fff",
                                        fontWeight: "bold",
                                        fontSize: "0.8rem",
                                        padding: "6px 8px",
                                        borderBottom: "none",
                                    },
                                }}>
                                    <TableCell>Item</TableCell>
                                    <TableCell>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {listItems.map((item, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{item}</TableCell>
                                        <TableCell>
                                            <SnpButton variant="contained" mbgcolor="#8a1104" size="small"
                                                onPointerDown={() => {
                                                    setListInput(item);
                                                    setPInput(item);
                                                }}
                                            >Edit</SnpButton>
                                            <DismissButton
                                                size="small"
                                                color="error"
                                                onPointerDown={() => deleteItem(index, "list")}
                                            >
                                                Delete
                                            </DismissButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        )
    }


    const renderMainDialogContent = () => {
        return (
            <div>
                <Grid container justifyContent="center" alignItems="center" spacing={1} sx={{ p: 1 }}>
                    {adminMode && <React.Fragment>
                        <Grid item xs={12} sm={4}>
                            <TextField label="Type" name="type" type="number" value={configs.type}
                                onChange={handleInputChange} fullWidth size="small" />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField label="Parent Default Value" name="defaultVal" fullWidth size="small"
                                value={Array.isArray(configs.defaultVal)
                                    ? configs.defaultVal.join(", ") : (typeof configs.defaultVal === "object"
                                        ? JSON.stringify(configs.defaultVal) : configs.defaultVal ?? "")}
                                onChange={handleInputChange} />
                        </Grid>
                        <Grid item xs={12}>
                            <Autocomplete multiple freeSolo options={[]} value={configs.groups || []}
                                onChange={(_, value) => setConfigs(prev => ({ ...prev, groups: value }))}
                                renderInput={(params) => <TextField {...params} label="Groups (type and press Enter)" />} />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField label="Value Type" name="valType" type="number" value={configs.valType}
                                onChange={handleInputChange} fullWidth size="small" inputProps={{ min: 1, max: 12 }} />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <FormControl component="fieldset">
                                <FormLabel>Visible</FormLabel>
                                <RadioGroup row name="visible" value={String(configs.visible)} onChange={handleInputChange}>
                                    <FormControlLabel value="true" control={<Radio />} label="Yes" />
                                    <FormControlLabel value="false" control={<Radio />} label="No" />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        {(Number(configs.valType) === ConfigInputType.DROPDOWN
                            || Number(configs.valType) === ConfigInputType.RADIO) &&
                            <Grid item xs={12}>
                                <Autocomplete multiple freeSolo options={[]} value={configs.optionsList || []}
                                    onChange={(_, value) => setConfigs(prev => ({ ...prev, optionsList: value }))}
                                    renderInput={(params) => <TextField {...params} label="Parent options (type and press Enter)" />} />
                            </Grid>}
                        {(Number(configs.valType) === ConfigInputType.MAP
                            || Number(configs.valType) === ConfigInputType.RADIO) &&
                            <Grid item xs={12}>
                                <TextField key={configs.featureId} fullWidth multiline minRows={3} label="Parent map (JSON key/value)"
                                    defaultValue={JSON.stringify(configs.optionsMap || {}, null, 2)}
                                    onBlur={(event) => {
                                        try {
                                            const value = JSON.parse(event.target.value || "{}");
                                            setConfigs(prev => ({ ...prev, optionsMap: value }));
                                        } catch (_) { /* retain the last valid map */ }
                                    }} />
                            </Grid>}
                    </React.Fragment>}
                    <Grid item md={12} sm={12} xs={12} lg={12} >
                        <TextField
                            id="configName"
                            disabled
                            label="Configuration Name"
                            name="configName"
                            value={configs.configNameStr}
                            variant="filled"
                            size="small"
                            helperText={isEmpty(configs.comments) && configs.comments}
                            style={{ width: "100%" }}
                        />
                    </Grid>
                    {
						configs.multiple &&
                        <Grid item md={12} sm={12} xs={12} lg={12} >
                            <TextField
                                id="prefix"
                                label="Config Type"
                                name="prefix"
                                value={configs.prefix}
                                variant="filled"
                                size="small"
                                style={{ width: "100%" }}
                            />
                        </Grid>
                    }
                    {adminMode && <React.Fragment>
                        <Grid item xs={12}>
                            <TextField name="val" label="val" value={configs.val ?? ""}
                                onChange={handleInputChange} fullWidth size="small" />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField name="valNum" label="valNum" type="number" value={configs.valNum ?? 0}
                                onChange={handleInputChange} inputProps={{ step: "any" }} fullWidth size="small" />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl component="fieldset">
                                <FormLabel component="legend">valBool</FormLabel>
                                <RadioGroup row name="valBool" value={String(configs.valBool)} onChange={handleInputChange}>
                                    <FormControlLabel value="true" control={<Radio />} label="Yes" />
                                    <FormControlLabel value="false" control={<Radio />} label="No" />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField name="valDate" label="valDate" type="datetime-local"
                                value={configs.valDate ? String(configs.valDate).slice(0, 16) : ""}
                                onChange={handleInputChange} InputLabelProps={{ shrink: true }} fullWidth size="small" />
                        </Grid>
                        <Grid item xs={12}>
                            <FormLabel component="legend">list</FormLabel>
                            {renderListView()}
                        </Grid>
                        <Grid item xs={12}>
                            <FormLabel component="legend">map</FormLabel>
                            <Grid container spacing={1}>
                                <Grid item xs={5}><TextField label="Key" value={mapKey} onChange={(e) => setMapKey(e.target.value)} fullWidth /></Grid>
                                <Grid item xs={5}><TextField label="Value" value={mapValue} onChange={(e) => setMapValue(e.target.value)} fullWidth /></Grid>
                                <Grid item xs={2}><SnpButton mbgcolor="#538796" onClick={() => { if (mapKey.trim()) { setMapItems(prev => ({ ...prev, [mapKey]: mapValue })); setMapKey(""); setMapValue(""); } }}>Add</SnpButton></Grid>
                                {Object.entries(mapItems).map(([key, value]) => <Grid item xs={12} key={key}>
                                    <span>{key}: {String(value)} </span>
                                    <SnpButton mbgcolor="#538796" onClick={() => { setMapKey(key); setMapValue(String(value)); }}>Edit</SnpButton>
                                    <DismissButton onClick={() => setMapItems(prev => { const next = { ...prev }; delete next[key]; return next; })}>Delete</DismissButton>
                                </Grid>)}
                            </Grid>
                        </Grid>
                    </React.Fragment>}
                    {!adminMode && <React.Fragment>
                    {
                        (configs.valType === ConfigInputType.ATTACHMENT && isEmpty(selectedImage)) &&
                        <Grid item md={8} sm={8} xs={8} lg={8} >
                            <TextField
                                accept="image/*"
                                id="imgPath"
                                name="imgPath"
                                label=""
                                multiple
                                type="file"
                                autoHighlight
                                size="small"
                                helperText="Enter Configuration Image(Image should be less than 2Mb.)"
                                onChange={handleInputChange}
                                fullWidth
                            />
                        </Grid>
                    }
                    {
                        (configs.valType === ConfigInputType.ATTACHMENT && !isEmpty(selectedImage)) &&
                        <Grid item md={4} sm={4} xs={4} lg={4} >
                            <Button variant="contained" color="primary" onClick={handleDeleteImage}>
                                Delete Image
                            </Button>
                        </Grid>
                    }
                    {
                        (configs.valType === ConfigInputType.ATTACHMENT && !isEmpty(selectedImage)) &&
                        <Grid item md={4} sm={4} xs={4} lg={4} >
                            <img
                                alt=""
                                style={{ height: "80px", width: "80px", borderRadius: "40%" }}
                                src={selectedImage}
                            />
                        </Grid>
                    }

                    {imageSelectedError &&
                        <p className="error" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>Please select the Image (image format) having size below 5Mb before uploading.</p>
                    }
                    {
                        configs.valType === ConfigInputType.LABEL &&
                        <Grid item md={12} sm={12} xs={12} lg={12} >
                            <TextField
                                id="val"
                                label="Enter Configuration Value"
                                name="val"
                                size="small"
                                defaultValue={configs.val}
                                onChange={handleInputChange}
                                fullWidth
                            />
                        </Grid>
                    }
                    {
                        (configs.valType === ConfigInputType.RADIO && !(configs.configName === DEFDASHBOARDSCREEN
                            || configs.configName === DEF_BILL_PRICES
                            || configs.configName === DEF_SELECT_SEARCH
                            || configs.configName === DEF_RESTO_BILLING_UI
                        )) &&
                        <Grid item md={12} sm={12} xs={12} lg={12}>
                            <FormControl component="fieldset">
                                <FormLabel component="legend">Select Configuration Value</FormLabel>
                                <RadioGroup aria-label="val" name="val" value={configs.val} onChange={handleInputChange} row={true}>
                                    {(Object.keys(configs.optionsMap || {}).length
                                        ? Object.entries(configs.optionsMap).map(([label, value]) => (
                                            <FormControlLabel key={label} value={String(value)} control={<Radio />} label={label} />
                                        ))
                                        : (configs.optionsList || []).length ? (configs.optionsList || []).map((value) => (
                                            <FormControlLabel key={value} value={String(value)} control={<Radio />} label={value} />
                                        )) : ["Yes", "No"].map(value => <FormControlLabel key={value} value={value} control={<Radio />} label={value} />))}
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                    }
                    {configs.valType === ConfigInputType.BOOL &&
                        <Grid item xs={12}>
                            <FormControl component="fieldset">
                                <FormLabel component="legend">Select Configuration Value</FormLabel>
                                <RadioGroup name="val" value={String(configs.val)} onChange={handleInputChange} row>
                                    <FormControlLabel value="true" control={<Radio />} label="Yes" />
                                    <FormControlLabel value="false" control={<Radio />} label="No" />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                    }
                    {(configs.valType === ConfigInputType.NUMBER || configs.valType === ConfigInputType.DATE || configs.valType === ConfigInputType.COLORPALLETE) &&
                        <Grid item xs={12}>
                            <TextField name="val" label="Configuration Value" fullWidth size="small"
                                type={configs.valType === ConfigInputType.NUMBER ? "number" : configs.valType === ConfigInputType.DATE ? "date" : "color"}
                                value={configs.val ?? ""} onChange={handleInputChange}
                                inputProps={configs.valType === ConfigInputType.NUMBER ? { step: "any" } : undefined}
                                InputLabelProps={configs.valType === ConfigInputType.DATE ? { shrink: true } : undefined} />
                        </Grid>
                    }
                    {
                        ((configs.valType === ConfigInputType.RADIO && (configs.configName === DEF_RESTO_BILLING_UI))) &&
                        <Grid item xs={12}>
                            <FormControl component="fieldset">
                                <FormLabel component="legend">Select Defaut Billing Screen</FormLabel>
                                <RadioGroup aria-label="val" name="val" value={configs.val} onChange={handleInputChange} row={true}>
                                    <FormControlLabel value={"1"} control={<Radio />} label="Old Billing With Mouse" />
                                    <FormControlLabel value={"2"} control={<Radio />} label="Billing With Keyboard/Mouse" />
                                    <FormControlLabel value={"3"} control={<Radio />} label="New Billing With Mouse" />
                                     <FormControlLabel value={"4"} control={<Radio />} label="Advance Billing" />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                    }
                    {
                        ((configs.valType === ConfigInputType.RADIO && (configs.configName === DEFDASHBOARDSCREEN))) &&
                        <Grid item md={12} sm={12} xs={12} lg={12}>
                            <FormControl component="fieldset">
                                <FormLabel component="legend">Select Defaut Dashboard Screen</FormLabel>
                                <RadioGroup aria-label="val" name="val" value={configs.val} onChange={handleInputChange} row={true}>
                                    <FormControlLabel value={DashboardComponent.REPORTMANAGEMENT.toString()} control={<Radio />} label="Owner Dashboard" />
                                    {
                                        isFeatureAllowed(BILLMGMT) &&
                                            storeActiveShopHash.cartType === CartDets.Resto ?
                                            <FormControlLabel value={DashboardComponent.BILLDETAILS.toString()} control={<Radio />} label="Billing Management" />
                                            :
                                            <FormControlLabel value={DashboardComponent.BILLCONNECTOR.toString()} control={<Radio />} label="Billing Management" />
                                    }
                                    {
                                        isFeatureAllowed(ONLINEBILLMGMT) &&
                                        <FormControlLabel value={DashboardComponent.ONLINE_BILL_MANAGEMENT.toString()} control={<Radio />} label="Online Billing Management" />
                                    }
                                    {
                                        isFeatureAllowed(BILLMGMT) &&
                                        <FormControlLabel value={DashboardComponent.RESTO_BILLING_UI.toString()} control={<Radio />} label="Billing Ui" />
                                    }
                                    
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                    }
                    {
                        ((configs.valType === ConfigInputType.RADIO && (configs.configName === DEF_BILL_PRICES))) &&
                        <Grid item md={12} sm={12} xs={12} lg={12}>
                            <FormControl component="fieldset">
                                <FormLabel component="legend">Select Defaut Dashboard Screen</FormLabel>
                                <RadioGroup aria-label="val" name="val" value={configs.val} onChange={handleInputChange} row={true}>
                                    {Object.entries(ChooseItemPrices).map(([key, value]) => (
                                        <FormControlLabel
                                            key={value}
                                            value={value}
                                            control={<Radio />}
                                            label={key.replace("_", " ")}
                                        />
                                    ))}

                                </RadioGroup>
                            </FormControl>
                        </Grid>
                    }
                    {
                        ((configs.valType === ConfigInputType.RADIO && (configs.configName === DEF_SELECT_SEARCH))) &&
                        <Grid item md={12} sm={12} xs={12} lg={12}>
                            <FormControl component="fieldset">
                                <FormLabel component="legend">Select Bill Search Choices</FormLabel>
                                <RadioGroup aria-label="val" name="val" value={configs.val} onChange={handleInputChange} row={true}>
                                    {
                                        isFeatureAllowed(COMBOMGMT)
                                            ?
                                            optionComboList.map((option) => (
                                                <FormControlLabel
                                                    key={option.id}
                                                    value={option.id}
                                                    control={<Radio />}
                                                    label={option.optName}
                                                />
                                            ))
                                            :
                                            optionList.map((option) => (
                                                <FormControlLabel
                                                    key={option.id}
                                                    value={option.id}
                                                    control={<Radio />}
                                                    label={option.optName}
                                                />
                                            ))
                                    }
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                    }
                    {
                        (configs.valType === ConfigInputType.DROPDOWN && (configs.configName === DEFBALANCETYPE)) &&
                        <Grid item md={12} xs={12} sm={6} lg={12}>
                            <Autocomplete
                                id="balance-type-label"
                                variant="filled"
                                size="small"
                                autoHighlight
                                options={listAcc}
                                onChange={handleBalanceTypeChanged}
                                getOptionLabel={(option) => option}
                                defaultValue={configs.val}
                                renderOption={(props, option) => (
                                    <Box
                                        component="li"
                                        {...props}
                                    >
                                        {option}
                                    </Box>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Default Balance type used in Dashboard"
                                        inputProps={{
                                            ...params.inputProps,
                                        }}
                                        style={{ width: "100%" }}
                                    />
                                )}
                            />
                        </Grid>
                    }
                    {(configs.valType === ConfigInputType.DROPDOWN && configs.configName !== DEFBALANCETYPE) &&
                        <Grid item xs={12}>
                            <Autocomplete options={configs.optionsList || []} value={configs.val || null}
                                onChange={(_, value) => setConfigs(prev => ({ ...prev, val: value || "" }))}
                                renderInput={(params) => <TextField {...params} label="Select Configuration Value" />} />
                        </Grid>
                    }
                    {
                        configs.valType === ConfigInputType.LIST &&
                        <Grid item xs={12}>
                            {renderListView()}
                        </Grid>
                    }
                    {
                        configs.valType === ConfigInputType.DATETIME &&
                        <Grid item xs={12}>
                            <SnpDateTimePicker dateTimeStr={configs.val}
                                setDateTimeStr={(dTStr) => setConfigs(prev => ({ ...prev, val: dTStr }))}
                            />
                        </Grid>
                    }
                    {configs.valType === ConfigInputType.MAP &&
                        <Grid item xs={12}>
                            <Grid container spacing={1}>
                                <Grid item xs={5}><TextField label="Key" value={mapKey} onChange={(e) => setMapKey(e.target.value)} fullWidth /></Grid>
                                <Grid item xs={5}><TextField label="Value" value={mapValue} onChange={(e) => setMapValue(e.target.value)} fullWidth /></Grid>
                                <Grid item xs={2}><SnpButton mbgcolor="#538796" onClick={() => { if (mapKey.trim()) { setMapItems(prev => ({ ...prev, [mapKey]: mapValue })); setMapKey(""); setMapValue(""); } }}>Add</SnpButton></Grid>
                                {Object.entries(mapItems).map(([key, value]) => <Grid item xs={12} key={key}>
                                    <span>{key}: {String(value)} </span>
                                    <SnpButton mbgcolor="#538796" onClick={() => { setMapKey(key); setMapValue(String(value)); }}>Edit</SnpButton>
                                    <DismissButton onClick={() => setMapItems(prev => { const next = { ...prev }; delete next[key]; return next; })}>Delete</DismissButton>
                                </Grid>)}
                            </Grid>
                        </Grid>
                    }
                    {configs.valType === ConfigInputType.RICH_LABEL && <Grid item xs={12}>
                        <div dangerouslySetInnerHTML={{ __html: configs.val || "" }} />
                        <SnpButton mbgcolor="#538796" onClick={() => setRichEditorOpen(true)}>Edit Rich Text / HTML</SnpButton>
						<AboutItemEditor open={richEditorOpen} value={configs.val} title={configs.configNameStr || "Rich Label"} onClose={() => setRichEditorOpen(false)}
							onSave={(value) => { setConfigs(prev => ({ ...prev, val: value })); setRichEditorOpen(false); }} />
                    </Grid>}
                    </React.Fragment>}
                    <Grid item md={12} sm={12} xs={12} lg={12}>
                        <TextField
                            id="comments"
                            variant="filled"
                            size="small"
                            label="Enter Comments"
                            name="comments"
                            defaultValue={configs.comments}
                            onChange={handleInputChange}
                            multiline={true}
                            rows={2}
                            style={{ width: "100%" }}
                        />
                    </Grid>
                    {
                        (isOtherRoleAllowed(OTHER_ADMIN_RIGHTS)) &&
                        <Grid item md={12} sm={12} xs={12} lg={12}>
                            <FormControl component="fieldset">
                                <FormLabel component="legend">Is Configuration Allowed(For Employee)</FormLabel>
                                <RadioGroup aria-label="allowed" name="allowed" value={configs.allowed} onChange={handleInputChange} row={true}>
                                    <FormControlLabel value={true} control={<Radio />} label="Yes" />
                                    <FormControlLabel value={false} control={<Radio />} label="No" />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                    }
                </Grid>
            </div>
        );
    }

    const renderDialogAction = () => {
        return (
            <React.Fragment>
                <SnpButton variant="contained" color="primary" mbgcolor="#538796" onClick={handleFileUpload}>
                    {isEditProduct ? "Update" : "Submit"}
                </SnpButton>
                <DismissButton variant="contained" color="primary" onClick={handleDialogClose}>
                    Dismiss
                </DismissButton>
            </React.Fragment>
        );
    }

    const renderSnpContent = () => {
        return (
            <React.Fragment>
                <PasswordDialog
                    open={showPassword}
                    onClose={() => {
                        setShowPassword(false);
                        setSnpComponent(prev => ({
                            ...prev,
                            snackBarMsg: "Incorrect passoword",
                            snackBarOpen: true,
                        }))
                    }}
                    onSuccess={(code) => {
                        setAdminCode(code);
                        setAdminMode(true);
                        getConfigs(true, code);
                        searchConfigurationFeatures("", code);
                        setShowPassword(false);
                    }}
                />

                <Grid container spacing={1}>
                    {
                        ((tableSystemAllowed || rangeDelvChangeAllowed) && storeActiveShopHash.cartType === CartDets.Resto) &&
                        <Grid item xs={12} style={{ display: "flex", flexDirection: "column" }}>
                            <div style={{ padding: 10 }}>

                                {
                                    tableSystemAllowed && <EnterButton
                                        variant="contained" color="primary" style={{ float: 'right' }} className="float-right" onClick={() =>
                                            navigate("/dashboard/tableconfig")
                                        }>
                                        Table Configuration
                                    </EnterButton>
                                }
                                {
                                    rangeDelvChangeAllowed && <EnterButton
                                        variant="contained" color="primary" style={{ float: 'right' }} className="float-right" onClick={() =>
                                            navigate("/dashboard/minrangedistance")
                                        }>
                                        Minimum Order/Distance Config
                                    </EnterButton>
                                }
                            </div>
                        </Grid>
                    }
                    <Grid item xs={12}>
                        <Grid container spacing={1} alignItems="center">
                            <Grid item xs={12} sm={8} md={6}>
                                <TextField
                                    fullWidth
                                    label="Search Configuration Name"
                                    placeholder="Enter configuration name"
                                    size="small"
                                    value={configSearchInput}
                                    onChange={(event) => handleConfigSearchInput(event.target.value)}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            const normalizedValue = configSearchInput.trim();
                                            setConfigSearch(normalizedValue.length >= 2 ? normalizedValue : "");
                                        }
                                    }}
                                    helperText="Search starts automatically after 2 characters"
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon sx={{ color: "#167553" }} />
                                            </InputAdornment>
                                        ),
                                        endAdornment: configSearchInput ? (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="Clear configuration search"
                                                    size="small"
                                                    onClick={() => handleConfigSearchInput("")}
                                                >
                                                    <ClearIcon fontSize="small" />
                                                </IconButton>
                                            </InputAdornment>
                                        ) : null,
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    {adminMode && <Grid item xs={12}>
                        <Paper sx={{ p: 2 }}>
                            <Grid container spacing={1} alignItems="center">
                                <Grid item xs={12} md={5}>
                                    <Autocomplete options={availableFeatures} value={selectedFeature}
                                        onInputChange={(_, value) => searchConfigurationFeatures(value)}
                                        onChange={(_, value) => setSelectedFeature(value)}
                                        getOptionLabel={(option) => option.configNameStr || option.configName || ""}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        renderInput={(params) => <TextField {...params} label="Search configuration from SnpFeatures" />} />
                                </Grid>
                                <Grid item xs={12} md={5}>
                                    <Autocomplete options={configurationUsers} value={selectedConfigUser}
                                        onChange={(_, value) => setSelectedConfigUser(value)}
                                        getOptionLabel={(option) => option.name || ""}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        renderInput={(params) => <TextField {...params} label="Add configuration to user" />} />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <SnpButton mbgcolor="#538796" disabled={!selectedFeature || !selectedConfigUser}
                                        onClick={addConfigurationFromFeature}>Add</SnpButton>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>}
                    <Grid item xs={12}>
                        <CustomDataGrid
                            getRowId={row => row.id}
                            rows={filteredConfigs}
                            columns={isOtherRoleAllowed(OTHER_ADMIN_RIGHTS) ? columnsAdmin : columns}
                            loading={snpComponent.isLoader}
                        />
                    </Grid>
                </Grid>


                < DialogBox
                    showDialog={showDialog}
                    title={isEditProduct ? "Update Configuration" : "Add Configuration"}
                    onClose={handleDialogClose}
                    dialogContent={renderMainDialogContent()}
                    dialogActions={renderDialogAction()}
                ></DialogBox>
                {videoModel.show && <YouTubeVideo videoId={videoModel.path} onDismiss={(e) => setVideoModel({ ...videoModel, show: false })} />}
                {videoModel.path && <SingleFab onClick={(e) => setVideoModel({ ...videoModel, show: true })} />}
            </React.Fragment>
        );
    }

    const handleSnackClose = () => {
        setSnpComponent({
            ...snpComponent,
            snackBarOpen: false,
            snackBarMsg: "",
        });
    };

    const onClose = () => {
        console.log("onClose=> configuration");
        window.opener = null;
        window.open("", "_self");
        window.close();
    };

    return (
        <React.Fragment>
            <SnpComponent
                content={renderSnpContent()}
                onSnackClose={handleSnackClose}
                snackBarOpen={snpComponent.snackBarOpen}
                snackBarMsg={snpComponent.snackBarMsg}
                outSideClickDismiss={snpComponent.outSideClickDismiss}
                showDialog={snpComponent.showDialog}
                title={snpComponent.title}
                subTitle={snpComponent.subTitle}
                negativeAction={snpComponent.negativeAction}
                positiveReq={snpComponent.positiveReq}
                positiveAction={snpComponent.positiveAction}
                negativeReq={snpComponent.negativeReq}
                cancelExtra={snpComponent.cancelExtra}
                onCancel={onClose}
            />

        </React.Fragment>
    );
}
